import { useEffect, useState } from "react";
import { api, fmtDateTime } from "../../lib/api";
import { toast } from "sonner";
import { ChevronDown, ChevronRight } from "lucide-react";

export const AdminLogs = () => {
  const [logs, setLogs] = useState([]);
  const [open, setOpen] = useState({});

  useEffect(() => {
    api.get("/sync/logs").then((r) => setLogs(r.data)).catch(() => toast.error("Erreur"));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">Traçabilité</div>
        <h1 className="font-display text-4xl mt-2">Historique des synchros</h1>
        <p className="text-sm text-neutral-600 mt-1">
          {logs.length} exécution{logs.length > 1 ? "s" : ""} récente{logs.length > 1 ? "s" : ""}.
        </p>
      </div>

      <div className="bg-white border border-[var(--line)] rounded-md overflow-hidden">
        <div className="grid grid-cols-[20px_1fr_100px_80px_80px_80px_110px] gap-3 px-4 py-3 text-[10px] uppercase tracking-widest text-neutral-500 border-b border-[var(--line)] bg-[var(--bg-cream)]">
          <div />
          <div>Date</div>
          <div>Statut</div>
          <div className="text-right">Analysés</div>
          <div className="text-right">Créés</div>
          <div className="text-right">Doublons</div>
          <div className="text-right">Déclencheur</div>
        </div>
        {logs.map((l, i) => {
          const isOpen = !!open[i];
          return (
            <div key={i} className="border-b border-[var(--line)] last:border-b-0">
              <button
                onClick={() => setOpen({ ...open, [i]: !isOpen })}
                data-testid={`log-row-${i}`}
                className="w-full grid grid-cols-[20px_1fr_100px_80px_80px_80px_110px] gap-3 px-4 py-3 items-center text-left text-sm hover:bg-[var(--bg-cream)]"
              >
                {isOpen ? <ChevronDown className="h-4 w-4 text-neutral-400" /> : <ChevronRight className="h-4 w-4 text-neutral-400" />}
                <span>{fmtDateTime(l.started_at)}</span>
                <span className={
                  l.status === "success" ? "text-emerald-600" :
                  l.status === "error" ? "text-[var(--red)]" : "text-amber-600"
                }>{l.status}</span>
                <span className="text-right tabular-nums">{l.scanned}</span>
                <span className="text-right tabular-nums text-emerald-700">{l.created}</span>
                <span className="text-right tabular-nums text-neutral-500">{l.skipped_duplicates}</span>
                <span className="text-right text-[10px] uppercase tracking-widest">
                  <span className={`px-2 py-1 rounded ${
                    l.trigger === "scheduled"
                      ? "bg-[var(--red-soft)] text-[var(--red)]"
                      : l.trigger === "enrich"
                        ? "bg-amber-50 text-amber-700"
                        : "bg-neutral-100 text-neutral-600"
                  }`}>{l.trigger}</span>
                </span>
              </button>
              {isOpen && (
                <div className="px-10 py-4 bg-[var(--bg-cream)] text-xs border-t border-[var(--line)] space-y-2">
                  <div>Fin : {fmtDateTime(l.finished_at)} · Sans provider : {l.skipped_no_provider}</div>
                  {l.errors?.length > 0 && (
                    <div className="text-[var(--red)]">
                      {l.errors.length} erreur(s) :
                      <ul className="mt-1 list-disc pl-5 space-y-0.5">
                        {l.errors.slice(0, 8).map((e, k) => <li key={k}>{e}</li>)}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
        {logs.length === 0 && (
          <div className="py-10 text-center text-sm text-neutral-500">
            Aucune exécution encore. Lancez une synchro depuis le tableau de bord.
          </div>
        )}
      </div>
    </div>
  );
};
